<template>
  <HeaderComp />

  <div class="wrapper-asset asset-first">
    <div class="title-wrap-asset">
      <h2>ASSET</h2>
      <p>DE HEUS INDONESIA</p>
    </div>
  </div>

  <div class="detail-wrapper" v-if="asset">
    <div class="detail-grid">
      <!-- Gallery -->
      <div class="gallery-section">
        <div class="gallery-main-wrapper">
          <!-- Main Image -->
          <div class="main-image">
            <img
              :src="selectedImage"
              :key="selectedImage"
              class="fade-img"
              alt="Main Asset Image"
            />
          </div>

          <!-- Thumbnails -->
          <div class="thumbnail-list">
            <img
              v-for="(img, idx) in asset.images"
              :key="idx"
              :src="img"
              :class="{ active: selectedImage === img }"
              @click="selectedImage = img"
            />
          </div>
        </div>
      </div>

      <!-- Info Section -->
      <div class="info-section">
        <h2>{{ asset.title }}</h2>
        <p class="address">{{ asset.address }}</p>
        <p class="price">Rp {{ formatNumber(asset.price) }}</p>
        <p class="specs">Luas {{ asset.area }} m²</p>

        <div class="tags">
          <span v-for="tag in asset.tags" :key="tag" class="badge">{{
            tag
          }}</span>
        </div>

        <div class="description">
          <h3>Deskripsi</h3>
          <p v-html="asset.description"></p>
        </div>
      </div>
    </div>
  </div>

  <FooterComp />
</template>

<script>
import HeaderComp from "@/components/template/HeaderComp.vue";
import FooterComp from "@/components/template/FooterComp.vue";

export default {
  name: "AssetDetailView",
  components: { HeaderComp, FooterComp },
  data() {
    return {
      isLoading: true,
      asset: null,
      selectedImage: null,

      // ✅ Dummy jika API gagal
      dummyList: [
        {
          slug: "dummy-1",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        {
          slug: "dummy-2",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        {
          slug: "dummy-3",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        {
          slug: "dummy-4",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        {
          slug: "dummy-5",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        {
          slug: "dummy-6",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        {
          slug: "dummy-7",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        {
          slug: "dummy-8",
          title: "TANAH 3.615 m² - BOGOR",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          content: "Tanah strategis di daerah Bogor",
          types: "TANAH",
          images: [
            require("@/assets/images/prop-1.jpg"),
            require("@/assets/images/prop-2.jpg"),
            require("@/assets/images/prop-3.jpg"),
          ],
        },
        // dummy lainnya...
      ],
    };
  },
  async mounted() {
    await this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      const slug = this.$route.params.slug;
      if (!slug) {
        console.error("Slug tidak ditemukan di route params");
        return;
      }

      if (slug.startsWith("dummy-")) {
        const dummy = this.dummyList.find((d) => d.slug === slug);
        if (dummy) {
          this.asset = {
            title: dummy.title,
            address: `${dummy.subdistrict_name}, ${dummy.district_name}`,
            price: Number(dummy.price),
            area: dummy.area,
            description: dummy.content,
            tags: dummy.types.split(",").map((t) => t.trim().toUpperCase()),
            images: dummy.images,
          };
          this.selectedImage = this.asset.images[0];
          return;
        }
      }

      try {
        const res = await fetch(
          `https://cms-property.cjfnc.id/api/post-detail/${slug}`,
        );
        const json = await res.json();
        const p = json?.data?.post;
        if (!p) throw "No API data";

        const cover = p.cover_image || "";
        const gallery = cover ? [cover] : [];
        if (json?.data?.images?.length) gallery.push(...json.data.images);
        const uniqueGallery = [...new Set(gallery)];

        this.asset = {
          title: p.title || "-",
          address: `${p.subdistrict_name || ""}, ${p.district_name || ""}, ${
            p.province_name || ""
          }`,
          price: Number(p.price) || 0,
          area: p.area || 0,
          description: p.content || "-",
          tags: json?.data?.types?.length
            ? json.data.types.map((t) => t.trim().toUpperCase())
            : p.types
            ? p.types.split(",").map((t) => t.trim().toUpperCase())
            : [],
          images: uniqueGallery,
        };
      } catch (err) {
        console.warn("API error, memakai dummy asset");
        this.asset = {
          title: this.dummyList[0].title,
          address: `${this.dummyList[0].subdistrict_name}, ${this.dummyList[0].district_name}`,
          price: Number(this.dummyList[0].price),
          area: this.dummyList[0].area,
          description: this.dummyList[0].content,
          tags: this.dummyList[0].types
            .split(",")
            .map((t) => t.trim().toUpperCase()),
          images: this.dummyList[0].images,
        };
      }

      this.selectedImage = this.asset.images[0];
    },

    formatNumber(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
  },
};
</script>

<style scoped>
.detail-wrapper {
  padding: 70px 40px;
  background: #fafafa;
}

.detail-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.gallery-section {
  display: flex;
  justify-content: center;
}

.gallery-main-wrapper {
  display: flex;
  gap: 15px;
}

/* Main image fade */
.main-image {
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  height: 500px;
  position: relative;
}
.fade-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Thumbnail */
.thumbnail-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-x: visible;
  max-height: 500px;
}
.thumbnail-list img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.3s ease;
}
.thumbnail-list img.active,
.thumbnail-list img:hover {
  opacity: 1;
  border: 2px solid #ff9600;
}

/* Info section (revisi lengkap) */
.info-section {
  flex: 1 1 400px;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}
.info-section h2 {
  font-size: 26px;
  margin-bottom: 10px;
}
.info-section .address {
  color: #666;
  margin-bottom: 10px;
}
.info-section .price {
  font-size: 22px;
  font-weight: bold;
  color: #ff9600;
  margin-bottom: 15px;
}
.info-section .specs {
  margin-bottom: 15px;
}
.info-section .tags {
  margin-bottom: 15px;
}
.info-section .badge {
  display: inline-block;
  background: #006dcd;
  color: #fff;
  padding: 4px 10px;
  margin: 0 5px 5px 0;
  border-radius: 6px;
  font-size: 12px;
}
.info-section .description {
  margin-top: 20px;
}

/* Responsive */
@media (max-width: 1024px) {
  .main-image img {
    height: 400px;
  }
  .thumbnail-list img {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 768px) {
  .detail-grid {
    flex-direction: column;
  }
  .main-image {
    height: 250px;
  }
  .thumbnail-list {
    flex-direction: row;
    overflow-x: auto;
    max-height: none;
  }
  .thumbnail-list img {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
  }
}

@media (max-width: 480px) {
  .detail-wrapper {
    padding: 10px 15px;
  }
  .main-image {
    height: 200px;
  }
  .thumbnail-list img {
    width: 40px;
    height: 40px;
  }
}
</style>
